import { useCallback, useEffect, useRef, useState } from 'react';
import { liveFollowOutput } from '@utils/editors/live-follow-output.ts';

export const useLiveFollowOutput = (viewingSection: boolean) => {
  const viewport = useRef<HTMLDivElement>(null);
  const [atBottom, setAtBottom] = useState(true);
  const [interacting, setInteracting] = useState(false);
  const updateInteraction = useCallback(() => {
    setInteracting(liveFollowOutput(viewport.current, true, false) === false);
  }, []);
  useEffect(() => {
    document.addEventListener('selectionchange', updateInteraction);
    return () =>
      document.removeEventListener('selectionchange', updateInteraction);
  }, [updateInteraction]);
  const afterBlur = useCallback(() => {
    queueMicrotask(updateInteraction);
  }, [updateInteraction]);
  const follow = useCallback(
    (bottom: boolean) =>
      liveFollowOutput(viewport.current, bottom, viewingSection),
    [viewingSection]
  );
  const resume = useCallback(() => {
    const selection = window.getSelection();
    if (selection && viewport.current?.contains(selection.anchorNode))
      selection.removeAllRanges();
    setInteracting(false);
  }, []);
  return {
    viewport,
    atBottomStateChange: setAtBottom,
    // Virtuoso also follows row resizes when this prop is truthy. Passing
    // false disables that path as well as append-follow while interacting.
    followOutput: atBottom && !interacting && !viewingSection ? follow : false,
    onFocusCapture: updateInteraction,
    onBlurCapture: afterBlur,
    resume
  } as const;
};
